export default __webpack_public_path__ + "static/media/assessment_white.ba4ed033.svg";